module.exports = __webpack_public_path__ + "img/account_100.ce76b079.jpg";